import { Subscription } from 'rxjs';
import { CampusGreetingsComponent } from './../campus-greetings/campus-greetings.component';
import { LocalService } from './../services/local.service';
import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  Inject,
  Output,
  EventEmitter,
} from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import Swal from 'sweetalert2';
import { StripeToken, StripeSource } from 'stripe-angular';
import { NgForm } from '@angular/forms';
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { analytics } from 'firebase';
import { log } from 'console';
@Component({
  selector: 'app-base-payment',
  templateUrl: './base-payment.component.html',
  styleUrls: ['./base-payment.component.css'],
})
export class BasePaymentComponent implements OnInit {
  @Output() updateTrackMenu = new EventEmitter();
  @ViewChild('cardInfo') cardInfo: ElementRef;
  existingCards: any = [];
  card: any;
  public invalidError: any;
  cardHandler = this.onChange.bind(this);
  error: string;
  promocode: string = '';
  applyCouponId: any;
  defaultCard: string;
  showSpinner: Boolean = true;
  enablePromo: Boolean = false;
  isCouponValid: Boolean = false;
  copuonAppliedMsg: string = '';
  discount: any = 0;
  coupon: string = '';
  couponApplied: Boolean = false;
  isDiscount: any;
  public cards = [];
  amount: any = 0;
  loadingMsg: string = 'Loading ...';
  planName: any;
  public user: any;
  public plan: any;
  public form: FormGroup;
  public range: any;
  public cardId: any;
  subscriptionId: any = '';
  spinnerType = SPINNER.circle;
  public isCouponApplied: any;
  bannerPlanId: any;
  bannerPlanData: any;
  price: any;
  bannerSizeData: any;
  cardForPayment: any;
  isDefault = false;
  public isBannerPlan: any;
  public isBannerSizePlan: any;
  public category: any;
  bannerSizeId: any;
  bannerCoupon: any;
  bannerDiscount: any;
  couponDetails: any;
  token: any;
  couponssId: any
  kingdomPartner: boolean = false;
  constructor(
    public fb: FormBuilder,
    public router: Router,
    private ngxService: NgxUiLoaderService,
    public authenticationService: AuthenticationService,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe((params: any) => {
      this.isDiscount = params.isDiscount;
      if (params.id) {
        this.subscriptionId = params.id;
      }
      this.category = params.category;
      this.bannerPlanId = params.bannerPlanId;
      if (this.bannerPlanId) {
        this.getBannerPlanById();
      }
      this.kingdomPartner = params.kingdomPartner === 'true';
    });
  }
  ngOnInit(): void {
    this.getProfile();
    // this.bannerCoupon = localStorage.getItem('couponId');
    // this.couponsId(this.bannerCoupon);
    this.plan = JSON.parse(localStorage.getItem('plan'));
    let criteria = {
      amount: this.plan?.price,
      discount: this.plan?.discount,
      couponApplied: this.couponApplied,
    };
    localStorage.setItem('criteria', JSON.stringify(criteria));
    this.range = JSON.parse(localStorage.getItem('range'));
    this.user = this.authenticationService.currentUserValue;
    this.cardList();
    this.form = this.fb.group({
      couponId: [
        {
          value: this.hasEarlyBirdOffer() ? 'EARLYBIRD' : '',
          disabled: this.hasEarlyBirdOffer(),
        },
      ],
    });

    if (this.subscriptionId) {
      this.authenticationService
        .getSubscriptionById(this.subscriptionId)
        .subscribe((res) => {
        });
    }

  }

  ngOnChanges(): void {
    this.updateCardValidation();
  }



  cardReady = false;
  extraData = {
    name: null,
    address_city: null,
    address_line1: null,
    address_line2: null,
    address_state: null,
    address_zip: null,
  };
  ngAfterViewInit() {
    this.card = elements.create('card');
    this.card.mount(this.cardInfo.nativeElement);
    this.card.addEventListener('change', this.cardHandler);
  }
  onStripeInvalid(error: Error) {
    console.log('Validation Error', error);
  }

  setStripeToken(token: StripeToken) {
    console.log('Stripe token', token);
  }

  setStripeSource(source: StripeSource) {
    console.log('Stripe source', source);
  }

  onStripeError(error: Error) {
    console.error('Stripe error', error);
  }
  ngOnDestroy() {
    this.card.removeEventListener('change', this.cardHandler);
    this.card.destroy();
  }

  onChange({ error }) {
    if (error) {
      this.error = error.message;
    } else {
      this.error = null;
    }
    // this.cd.detectChanges();
  }

  addCard(card, token) {
    let data = {
      stripeToken: token,
      card: card,
    };
    this.authenticationService.addCard(data).subscribe(
      (data) => {
        this.ngxService.stop();
        this.cardList();
        Swal.fire('', 'Card is added successfully', 'success');
      },
      (error) => {
        this.ngxService.stop();
        Swal.fire('Error', error.error.message, 'error');
      }
    );
  }

  setDefault(data: any) {
    if (data) {
      this.isDefault = true;
      (this.cardId = data.id), (this.defaultCard = data.id);
      this.cardForPayment = data;
    }
  }

  openCardModal() {
    this.isDefault = false;
  }

  updateCardValidation(): void {
    if (!this.form) {
      return; // Avoid errors if form is not initialized yet
    }
    const cardControl = this.form.get('cardInfo');
    if (this.plan?.caption === 'Congregational') {
      cardControl?.clearValidators(); // Remove required validator for Congregational
    } else {
      cardControl?.setValidators(Validators.required); // Add required validator for other plans
    }
    cardControl?.updateValueAndValidity(); // Ensure validation updates
  }

  async onSubmit(form: NgForm) {
    this.ngxService.start();
    const { token, error } = await stripe.createToken(this.card);
    if (error) {
      Swal.fire('error', 'Oops...', error.message);
      this.ngxService.stop();
      // this.showSpinner = false;
    } else {
      if (token?.card?.id) {
        this.isDefault = false;
        this.defaultCard = '';
        this.cardForPayment = token?.card;
        this.addCard(token?.card?.id, token?.id);
      }
      // if (token.id) {
      //   this.addCard(token.id);
      // }
      // this.basicSubscription(token.id)
    }
  }
  removeCard(cardId) {
    this.ngxService.start();
    this.authenticationService.removeCard({ cardId: cardId }).subscribe(
      (data) => {
        this.copuonAppliedMsg = 'Card is removed successfully';
        this.ngxService.stop();
        this.cardList();
        Swal.fire('', this.copuonAppliedMsg, 'success');
      },
      (error) => {
        this.ngxService.stop();
      }
    );
  }

  cardList() {
    this.authenticationService.cardList().subscribe(
      (data) => {
        this.cards = data['data'].cards;
        if (this.cards && this.cards.length > 0) {
          this.cardId = this.cards[0].id;
          this.defaultCard = data['data']['defaultCard'];
        } else {
          this.cardId = '';
        }
      },
      (error) => {
        if (error.error.message == 'Unauthorized') {
          this.authenticationService.logout();
        }
      }
    );
  }

  // couponsId(id: any) {
  //   this.authenticationService.getCouponId(id).subscribe(
  //     (data:any) => {
  //       console.log('Coupon Data:', data);
  //       // this.processCouponData(data);
  //       this.bannerDiscount = data.data.amount_off/100
  //       console.log("bannerDiscountTodollar>>>>",this.bannerDiscount)
  //     },
  //     (error) => {
  //       console.error('Error fetching coupon data:', error);
  //     }
  //   );
  // }

  // processCouponData(data: any) {
  //   this.couponDetails = data;
  // }

  basicSubscription(token: any) {
    // this.router.navigate(['/payment-sucess']);
    if (!token || token == undefined) {
      Swal.fire('Error', 'Please add your card to continue payment.', 'error');
      return;
    } else {
      let subObj = {
        planId: this.plan._id,
        stripeToken: '',
        isRecurring: false,
        isCouponApplied: 'true',
        couponId: '', // Initially set couponId as empty
        amount: this.plan.price,
        kingdomPartner: this.kingdomPartner,
      };
      console.log("subobj>>>>>>>>", subObj)
      subObj['planId'] = this.plan._id;
      subObj['stripeToken'] = token;
      subObj['isRecurring'] = false;
      subObj['isCouponApplied'] = 'true';
      subObj['couponId'] = '';
      subObj['amount'] = this.plan.price;
      subObj['kingdomPartner'] = this.kingdomPartner;
      this.ngxService.start();
      this.authenticationService.basicSubscription(subObj).subscribe(
        (data) => {

          // Save couponId to localStorage if available
          // if (data?.data?.couponId) {
          //   localStorage.setItem('couponId', data.data.couponId);
          //   subObj.couponId = data.data.couponId;
          // }
          // this.couponsId(subObj.couponId);
          localStorage.setItem('planDetail', JSON.stringify(this.plan));
          localStorage.removeItem('bannerPlanData');
          this.cardList();
          this.ngxService.stop();
          Swal.fire({
            title: 'Thank you',
            html: 'Your profile is now searchable for members of any congregation and all users globally!<br><br>' +
              'Design a member discount, place a front page Business Banner, or post Ads to attract more customers.',
            icon: 'success'
          });
          this.router.navigate(['/payment-sucess']);
        },
        (error) => {
          this.ngxService.stop();
          Swal.fire('error', error.error.message, 'error');
          if (
            error.error.message == 'You already have subscribed to base plan'
          ) {
            this.router.navigate(['/dashboard']);
          }
        }
      );
    }
  }

  applyCoupon(coupon) {
    this.applyCouponId = coupon.couponId;
    this.ngxService.start();
    this.authenticationService
      .coupon({ couponId: this.applyCouponId, amount: this.plan.price })
      .subscribe(
        (data) => {
          this.couponApplied = true;
          Swal.fire('', 'Coupon is applied successfully', 'success');
          this.ngxService.stop();
        },
        (error) => {
          Swal.fire('Error', error.error.message, 'error');
          this.ngxService.stop();
        }
      );
  }
  redirect() {
    this.router.navigate(['/dashboard']);
  }
  convertSubscripitonType(days: any) {
    if (days === 365) {
      return 'Yearly';
    } else if (days === 30) {
      return 'Monthly';
    } else if (days === 90) {
      return 'Quarterly';
    } else if (days === 180) {
      return 'Half Yearly';
    }
    return 'Days';
  }
  getProfile() {
    this.authenticationService.getProfile().subscribe(
      (response: any) => {
        if (response && response?.data) {
          this.getPlanById(response?.data?.subscriptionPlanType);
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }
  getPlanById(id: any) {
    this.authenticationService.getPlanById(id).subscribe(
      (response: any) => {
        if (response && response?.data) {
          this.planName = response?.data?.caption;
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }
  getBannerPlanById() {
    this.authenticationService.getBannerPlanById(this.bannerPlanId).subscribe(
      (res: any) => {
        this.bannerPlanData = res?.data;
        this.plan = this.bannerPlanData;
        if (this.isDiscount == 'true') {
          this.price = this.bannerPlanData?.price;
        } else this.price = this.bannerPlanData?.price;
        this.discount = this.bannerPlanData.price / 2;
        this.ngxService.stop();
      },
      (error) => {
        this.ngxService.stop();
        Swal.fire('error', error.error.message, 'error');
      }
    );
  }

  bannerPlanSubscription(token: any) {
    if (!token || token == undefined) {
      Swal.fire('Error', 'Please add your card to continue payment.', 'error');
      return;
    } else {
      let subObj = {};
      subObj['planId'] = this.bannerPlanId;
      subObj['stripeToken'] = token;
      subObj['isRecurring'] = true;
      subObj['days'] = 30;
      subObj['amount'] = parseInt(this.price);
      subObj['isDiscount'] = this.isDiscount;

      this.ngxService.start();
      this.authenticationService.bannerSubscription(subObj).subscribe(
        (data) => {
          this.bannerPlanData.price = this.price;
          localStorage.setItem(
            'bannerPlanData',
            JSON.stringify({ bannerPlanData: this.bannerPlanData })
          );
          this.ngxService.stop();
          Swal.fire(
            'Thank you',
            'Your Business Banner is now visible in the\n"What Do You Need?"\nsection of the Ravel.Faith home page.',
            'success'
          );
          localStorage.removeItem('planDetail');
          this.router.navigate(['/payment-sucess']);
        },
        (error) => {
          this.ngxService.stop();
          Swal.fire('error', error.error.message, 'error');
        }
      );
    }
  }

  cancelSubs() {
    this.router.navigateByUrl('/mysubscration?isSub=true');
  }

  hasEarlyBirdOffer(): boolean {
    const caption = this.plan?.caption || '';
    return caption === 'Founding Partner' || caption === 'Founder';
  }

  getPayableAmount(): number {
    if (!this.plan?.price) {
      return 0;
    }
    if (!this.hasEarlyBirdOffer()) {
      return this.plan.price;
    }
    if (this.plan.price === 995) {
      return this.plan.price - 500;
    }
    return this.plan.price - this.plan.price * 0.35;
  }
}
